import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Horse } from '../types/content';
import { fmt } from '../utils/format';
interface HorseCardProps {
  horse: Horse;
}
export function HorseCard({
  horse
}: HorseCardProps) {
  const {
    t,
    l
  } = useLanguage();
  return <article data-id="element-191" data-mp="1z9elrkepelqh">
      <div className="aspect-[4/3] overflow-hidden rounded-lg bg-linen" data-id="element-192" data-mp="1z8wi42ppp58j">
        <img src={horse.image} alt={horse.name} className="h-full w-full object-cover" loading="lazy" data-id="element-193" data-mp="1la58ashvu5q7" />
      </div>
      <h4 className="mt-4 font-serif text-2xl font-bold text-bark" data-id="element-194" data-mp="1pc0adz7n0n51">{horse.name}</h4>
      <p className="mt-0.5 text-sm font-medium text-saddle" data-id="element-195" data-mp="1bbz76d3wh3me">
        {l(horse.breed)} · {fmt(t.horses.age, {
        n: horse.age
      })}
      </p>
      <p className="mt-2 text-[15px] leading-relaxed text-bark/80" data-id="element-196" data-mp="1gbvfgojmrh7r">{l(horse.temperament)}</p>
    </article>;
}